import { Toaster } from 'react-hot-toast';
import { Provider } from "react-redux";
import { useLocation } from 'react-router-dom';
import AclGuard from './components/auth/AclGuard';
import AuthGuard from './components/auth/AuthGuard';
import GuestGuard from './components/auth/GuestGuard';
import Spinner from './components/spinner';
import { defaultACLObj } from './configs/acl';
import { isGuest } from './configs/appConfig';
import themeConfig from './configs/themeConfig';
import { AuthProvider } from './context/AuthContext';
import Router from './routes';
import { store } from './store';
import ReactHotToast from './styles/react-hot-toast';
import ThemeProvider from './theme';

const Guard = ({ children, authGuard, guestGuard }) => {
  if (guestGuard) {
    return <GuestGuard fallback={<Spinner />}>{children}</GuestGuard>
  } else if (!guestGuard && !authGuard) {
    return <>{children}</>
  } else {
    return <AuthGuard fallback={<Spinner />}>{children}</AuthGuard>
  }
}

const App = () => {
  const authGuard = true
  const { pathname } = useLocation();
  const guestGuard = isGuest(pathname)
  const aclAbilities = defaultACLObj

  return (
    <Provider store={store}>
      <AuthProvider>
        <ThemeProvider>
          <ReactHotToast>
            <Toaster position={themeConfig.toastPosition} toastOptions={{ className: 'react-hot-toast' }} />
          </ReactHotToast>
          <Guard authGuard={authGuard} guestGuard={guestGuard}>
            <AclGuard aclAbilities={aclAbilities} guestGuard={guestGuard}>
              <Router />
            </AclGuard>
          </Guard>
        </ThemeProvider>
      </AuthProvider>
    </Provider>
  );
}

export default App